import packageJson from "../package.json";

/**
 * Global application configuration type definition
 */
export type GlobalConfig = {
  /** Application name */
  appName: string;
  /** Application version number */
  appVersion: string;
  /** Unique build version used to detect deployed updates */
  buildVersion: string;
  /** Default route path for the application */
  defaultRoute: string;
  /** Public path for static assets */
  publicPath: string;
  /** Base URL for API endpoints */
  apiBaseUrl: string;
  /** Base URL for the MockService API */
  mockApiBaseUrl: string;
  /** Whether mock configuration tools are available in this build */
  mockConfigEnabled: boolean;
  /** Whether this build is deployed to the testing environment */
  isTestEnvironment: boolean;
  /** Routing mode: frontend routing or backend routing */
  routerMode: "frontend" | "backend";
  authority: string;
};

/**
 * Global configuration constants
 * Reads configuration from environment variables and package.json
 *
 * @warning
 * Please don't use the import.meta.env to get the configuration, use the GLOBAL_CONFIG instead
 */
export const GLOBAL_CONFIG: GlobalConfig = {
  appName: "BiuPay",
  appVersion: packageJson.version,
  buildVersion: import.meta.env.VITE_APP_BUILD_VERSION || packageJson.version,
  defaultRoute: import.meta.env.VITE_APP_DEFAULT_ROUTE || "/dashboard",
  publicPath: import.meta.env.VITE_APP_PUBLIC_PATH || "/",
  apiBaseUrl: import.meta.env.VITE_APP_API_BASE_URL || "/api",
  mockApiBaseUrl: import.meta.env.VITE_APP_MOCK_API_BASE_URL || "/mock",
  mockConfigEnabled: import.meta.env.MODE === "development",
  isTestEnvironment: import.meta.env.VITE_APP_IS_TEST_ENV === "true",
  routerMode: import.meta.env.VITE_APP_ROUTER_MODE || "frontend",
  authority: import.meta.env.VITE_APP_AUTHORITY,
};
